import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
export const OTPTimer = ({ OTPMin, OTPSec, SendOTP }) => {
    const [minutes, setMinutes] = useState(OTPMin);
    const [seconds, setSeconds] = useState(OTPSec);
    useEffect(() => {
        const interval = setInterval(() => {
            if (seconds > 0) {
                setSeconds(seconds - 1);
            }

            if (seconds === 0) {
                if (minutes === 0) {
                    clearInterval(interval);
                } else {
                    setSeconds(59);
                    setMinutes(minutes - 1);
                }
            }
        }, 1000);

        return () => {
            clearInterval(interval);
        };
    }, [seconds]);
    const resendOTP = () => {
        setMinutes(1);
        setSeconds(30);
        SendOTP();
    };
    return <div className="countdown-text">
        {seconds > 0 || minutes > 0 ? (
            <p>
                OTP expires in:{" "}
                <span>
                    <i className="far fa-clock"></i> {minutes < 10 ? `0${minutes}` : minutes}:
                    {seconds < 10 ? `0${seconds}` : seconds}</span>
            </p>
        ) : (
            <p>
                {/*    Didn't recieve code?*/}
                {/*    {!(seconds > 0 || minutes > 0) && <button className="ResendOtp" style={{ marginLeft: "10px" }} id="confirmOTP" onClick={resendOTP} >*/}
                {/*    Resend OTP*/}
                {/*</button>}*/}
            </p>
        )}


    </div>
}
OTPTimer.propTypes = {
    OTPMin: PropTypes.number,
    OTPSec: PropTypes.number,
    SendOTP: PropTypes.func
}
